import OWContainer from 'styles/styled-components/ow-container';
import { Spinner } from 'components/design';
import useController from '../controllers/edit-product-category-controller';
import { ProductCategoryForm } from '../components/product-categories-form';

export const EditProductCategoryRoute = () => {
    const { formData, onChange, onSubmit, onCancel, dataChanged, isLoading, isEditProductCategoryLoading, errors } =
        useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <ProductCategoryForm
                    formData={formData}
                    onChange={onChange}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    disableSubmit={!dataChanged}
                    isSaveLoading={isEditProductCategoryLoading}
                    errors={errors}
                />
            )}
        </OWContainer>
    );
};
